import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import "./Hashtag.css";
const Hashtag = ({ tag }) => {
    return (_jsx("span", { className: "hashtag", children: _jsxs(Link, { to: `/t/${tag}`, onClick: e => e.stopPropagation(), children: ["#", tag] }) }));
};
export default Hashtag;
